import {
  DocumentCard,
  DocumentCardActivity,
  DocumentCardDetails,
  DocumentCardPreview,
  DocumentCardTitle,
  IDocumentCardPreviewProps,
  DocumentCardType,
  IDocumentCardActivityPerson,
  DocumentCardStatus,
} from '@fluentui/react/lib/DocumentCard';
import { getTheme } from '@fluentui/react/lib/Styling';
import { DetailsListView } from '../../Common/DetailsList/DetailListView';
import { timeSince } from '../../../common/list-utils';
import { useTranslation, Trans } from 'react-i18next';
const theme = getTheme();
const { palette, fonts } = theme;

export const ActivityCardList = (props: any) => {
  const { t, i18n } = useTranslation();
  const getPeople = (
      owner_actividad_iniciales: string,
      owner_actividad_nombre: string,
      owner_actividad_img_url: string
  ): IDocumentCardActivityPerson[] => {
    return [
      {
        name: owner_actividad_nombre,
        profileImageSrc: owner_actividad_img_url,
        initials: owner_actividad_iniciales,
      },
    ];
  };

  const previewPropsUsingIcon: IDocumentCardPreviewProps = {
    previewImages: [
      {
        previewIconProps: {
          iconName: 'Edit',
          styles: { root: { fontSize: fonts.superLarge.fontSize, color: palette.white } },
        },
        width: 144,
      },
    ],
    styles: { previewIcon: { backgroundColor: palette.themePrimary } },
  };

  const mapCard = (activity: any, i: number) => {
    return (
        <div className="ms-Grid-col ms-sm6 ms-md12 ms-lg6 ms-xl4" key={i}>
          <DocumentCard className="size-document-card" type={DocumentCardType.compact}>
            <DocumentCardPreview {...previewPropsUsingIcon} className="size-logo" />
            <DocumentCardDetails>
              <DocumentCardTitle title={activity.act_nombre} shouldTruncate />
              <DocumentCardTitle
                  title={t('Proyecto: ') + activity.pro_nombre}
                  className="proyect-title"
                  showAsSecondaryTitle
              />

              <DocumentCardStatus statusIcon="attach" status={t(' 3 Documentos')} />

              <DocumentCardActivity
                  activity={timeSince(activity.act_inicio)}
                  people={getPeople(
                      activity.owner_actividad_iniciales,
                      activity.owner_actividad_nombre,
                      activity.owner_actividad_img_url
                  )}
              />
            </DocumentCardDetails>
          </DocumentCard>{' '}
        </div>
    );
  };

  return (
      <DetailsListView
          changeBlockUI={props.changeBlockUI}
          keyList={props.keyList}
          onClickCardMode={() => props.onClickCardMode()}
          onClickGridMode={() => props.onClickGridMode()}
          title={t('Actividades')}
          mode={props.mode}
          isGridList={false}
          // virtualize={false}
          onItemClick={props.onItemClick}
          listFilters={[]}
          quickFilters={props.quickFilters}
          baseUrl={props.baseUrl}
          mapCard={mapCard}
          shouldUpdate={props.shouldUpdate}
          courier={props.courier}
      ></DetailsListView>
  );
};
